/**
 * Do not edit directly
 * Generated on Thu, 19 Aug 2021 21:48:11 GMT
 */
export const StrokeS = "1px";
export const StrokeM = "2px";
export const StrokeL = "3px";
export const StrokeXl = "4px";
